import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "14",
  fill: "none",
  "aria-hidden": "true",
  "data-pc-section": "unmaskicon",
  viewBox: "0 0 14 14"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M.054 7.252C.209 7.592 2.404 12.4 7 12.4s6.791-4.808 6.947-5.148l.005-.012a.62.62 0 0 0 0-.48l-.005-.012C13.79 6.408 11.596 1.6 7 1.6S.209 6.408.054 6.748l-.006.012a.62.62 0 0 0 0 .48zM7 11.2c-3.336 0-5.264-3.28-5.736-4.2.472-.92 2.4-4.2 5.736-4.2s5.264 3.28 5.736 4.2c-.472.92-2.4 4.2-5.736 4.2M5.556 9.162A2.6 2.6 0 0 0 7 9.6 2.61 2.61 0 0 0 9.6 7a2.6 2.6 0 1 0-4.044 2.162m.666-3.326A1.4 1.4 0 0 1 7 5.6 1.41 1.41 0 0 1 8.4 7a1.4 1.4 0 1 1-2.178-1.164",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }